import { HHTextField } from '@hinge-health/react-component-library';
import { Autocomplete } from '@mui/material';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { PartnershipType } from '../../types';

export interface PartnershipSelectProps {
  options: PartnershipType[];
  loading: boolean;
  disabled?: boolean;
  error?: FieldError;
  hint?: string;
  onAfterChange?: () => void;
}

export const PartnershipSelect = ({
  options,
  loading,
  disabled = false,
  error,
  hint,
  onAfterChange,
}: PartnershipSelectProps): JSX.Element => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name="partnershipId"
      render={({ field: { onChange, value } }): JSX.Element => (
        <Autocomplete
          value={options.find(p => p.id === value) ?? null}
          options={options}
          getOptionLabel={(option): string => option.name}
          isOptionEqualToValue={(option, val): boolean => option.id === val?.id}
          onChange={(_, newValue): void => {
            onChange(newValue?.id ?? null);
            onAfterChange?.();
          }}
          disabled={disabled}
          loading={loading}
          renderInput={(params): JSX.Element => (
            <HHTextField
              {...params}
              hhVariant="variant-bypass"
              variant="outlined"
              label="Partnership"
              error={!!error}
              helperText={error?.message ?? (!value ? hint : undefined)}
              inputProps={{ ...params.inputProps, name: 'partnershipId' }}
              data-testid="form-partnership-input"
            />
          )}
        />
      )}
    />
  );
};
